import React, { useEffect } from "react";
import { Button } from "reactstrap";
import { connect } from "react-redux";

import useModal from "../../../../../hooks/useModal";
import { createCouponSubscription } from "../../../../../store/dashboard/Coupons/actions";
import CouponSubscriptionModal from "../../../../../components/Modals/CouponSubscriptionModal/CouponSubscriptionModal";

const CreateCouponButtonSubscriptions = ({
  coupons,
  createCouponSubscription,
  text = 'Create subscription coupon',
}) => {
  const { loading, created } = coupons;
  const [modalVisible, toggleModal] = useModal();
  
  const handleCreateCouponClick = () => toggleModal(true);
  const handleCreateCouponConfirmed = (model) => createCouponSubscription(model);
  
  useEffect(() => {
    if (!loading && created) {
      toggleModal(false);
    }
  }, [loading, created]);
  
  return (
    <>
      <Button color="primary" onClick={handleCreateCouponClick}>
        {text}
      </Button>
      <CouponSubscriptionModal
        isOpen={modalVisible}
        onConfirm={handleCreateCouponConfirmed}
        onCancel={() => toggleModal(false)}
      />
    </>
  );
};

const mapStateToProps = ({ Coupons: coupons }) => ({ coupons });

export default connect(mapStateToProps, { createCouponSubscription })(CreateCouponButtonSubscriptions);
